import {InitPageStrict} from "../../index";
import WaveItemCheckboxManager from "./wave_item_checkbox_manager";

declare var removeItemPath: string;
declare var deleteNotePath: string;
declare var createNotePath: string;
declare var unpickAssetPath: string;
declare var canDeleteNotes: boolean;
declare var waveOrderMode: number | null;

interface ApiResponse {
    success: boolean;
    message: string;
    note?: {
        id: number;
        note: string;
        important: boolean;
        created_at: string;
        user_name: string;
    };
}

class WOPPickingShow {
    private removeItemModal: JQuery<HTMLElement>;
    private removeItemBtn: JQuery<HTMLElement>;
    private removeItemIdInput: JQuery<HTMLInputElement>;
    private removeItemIdsInput: JQuery<HTMLInputElement>;
    private removeItemReasonTextarea: JQuery<HTMLTextAreaElement>;
    private removeItemActionRadios: JQuery<HTMLElement>;
    private removeItemConfirmation: JQuery<HTMLElement>;
    private removeItemModalTitle: JQuery<HTMLElement>;

    constructor() {
        this.initializeElements();
        this.bindEvents();
    }

    private initializeElements(): void {
        this.removeItemModal = $("#removeItemModal");
        this.removeItemBtn = $("#confirm-remove-item-btn");
        this.removeItemIdInput = $("#remove-item-id");
        this.removeItemIdsInput = $("#remove-item-ids");
        this.removeItemReasonTextarea = $("#remove_item_reason");
        this.removeItemActionRadios = $("input[name='remove_item_action']");
        this.removeItemConfirmation = $("#remove-item-confirmation");
        this.removeItemModalTitle = $("#remove-item-modal-title");
    }

    private bindEvents(): void {
        this.initializeSelect2();
        
        // Handle remove item button click
        $(document).on('click', '.remove-item-btn', (e: JQuery.ClickEvent) => {
            this.handleRemoveItemClick(e);
        });

        // Handle confirm remove button click
        this.removeItemBtn.on('click', () => {
            this.handleConfirmRemove();
        });

        // Handle radio button changes for action selection
        this.removeItemActionRadios.on('change', () => {
            this.updateConfirmationMessage();
        });

        // Reset modal when closed
        this.removeItemModal.on('hidden.bs.modal', () => {
            this.resetModal();
        });
        
        // Also reset when modal is shown to ensure clean state (only for single item removal, not bulk)
        this.removeItemModal.on('show.bs.modal', () => {
            // Only hide cancel option if this is NOT a bulk delete (check if bulk item IDs are empty)
            const bulkItemIds = this.removeItemIdsInput.val() as string;
            if (bulkItemIds && bulkItemIds.trim().length > 0) {
                // This is bulk delete, don't hide here - let handleBulkDeleteCancelOption handle it
                return;
            }
            
            // For single item removal, don't hide here - let handleRemoveItemClick handle it
            // The handleRemoveItemClick method already sets the visibility correctly based on isLastItem
        });

        // Export button
        $('.export-button').on("click", () => {
            $("#export-dialog").modal('show');
        });

        // Change status button
        $('.change_status').on('click', (e: JQuery.ClickEvent) => {
            e.preventDefault();
            $('#changeStatusModal').modal('show');
        });

        // Accordion arrow icon toggle
        $(".accordion-arrow-icon").on("click", (e: JQuery.ClickEvent) => {
            const target = e.target as HTMLElement;
            if (target.classList.contains("fa-chevron-down")) {
                target.classList.remove("fa-chevron-down");
                target.classList.add("fa-chevron-up");
            } else {
                target.classList.add("fa-chevron-down");
                target.classList.remove("fa-chevron-up");
            }
        });

        // EPC modal handler
        $('.open-showEpc').on('click', (e: JQuery.ClickEvent) => {
            e.preventDefault();
            const epcValue = $(e.currentTarget).data('id') as string;
            $('#epc-value').text(epcValue);
            $('#showEPc').modal('show');
        });

        // Note deletion
        $(document).on('click', '.delete-wave-note', (e: JQuery.ClickEvent) => {
            this.handleDeleteNote(e);
        });

        // Note creation
        $('#createWaveNoteBtn').on('click', (e: JQuery.ClickEvent) => {
            this.handleCreateNote(e);
        });

        // Asset unpick
        $(document).on('click', '.unpick-asset-btn', (e: JQuery.ClickEvent) => {
            this.handleUnpickAsset(e);
        });
    }

    private initializeSelect2(): void {
        $('.select2-assign-user').select2({
            placeholder: 'Select a user',
            allowClear: false,
            width: '100%'
        });

        // Submit form when user changes
        $('.select2-assign-user').on('change', () => {
            $('#assign-user-form').submit();
        });
    }

    private handleRemoveItemClick(e: JQuery.ClickEvent): void {
        e.preventDefault();

        const $btn = $(e.currentTarget);

        // Check if button is disabled
        if ($btn.hasClass('disabled') || $btn.css('pointer-events') === 'none') {
            return;
        }

        const itemId = $btn.data('item-id') as string;
        const itemNumber = $btn.data('item-number') as string;
        // Handle both boolean and string values from data attribute
        const isLastItemData = $btn.data('is-last-item');
        const isLastItem = isLastItemData === true || isLastItemData === 'true' || isLastItemData === 1;

        // Set the item ID in the hidden field
        this.removeItemIdInput.val(itemId);

        // Clear the reason field and set default action
        this.removeItemReasonTextarea.val('');
        
        // Handle MODE_SO_MULTI, MODE_SO_MULTI_CL, MODE_SO_MULTI_AMZ, and MODE_SO_MULTI_AMZ_CL: show/hide cancel option based on isLastItem
        const MODE_SO_MULTI = 2;
        const MODE_SO_MULTI_CL = 7;
        const MODE_SO_MULTI_AMZ = 4;
        const MODE_SO_MULTI_AMZ_CL = 9;
        const MODE_SO_MULTI_CUSTOMER = 14;
        
        const cancelLabel = $('#remove_item_action_cancel_label');
        const cancelContainer = $('#remove_item_action_cancel_container');
        const cancelShopifyNote = $('.remove_item_cancel_shopify_note');
        const cancelRadio = $('#remove_item_action_cancel');
        
        // Handle MODE_SO_MULTI, MODE_SO_MULTI_CL, MODE_SO_MULTI_AMZ, and MODE_SO_MULTI_AMZ_CL: show/hide cancel option based on isLastItem
        if (typeof waveOrderMode !== 'undefined' && 
            (waveOrderMode === MODE_SO_MULTI || waveOrderMode === MODE_SO_MULTI_CL || 
             waveOrderMode === MODE_SO_MULTI_AMZ || waveOrderMode === MODE_SO_MULTI_AMZ_CL || waveOrderMode === MODE_SO_MULTI_CUSTOMER)) {
            
            // Only show cancel option if this is the last item for the sales order
            if (isLastItem) {
                cancelLabel.show();
                cancelContainer.show();
                cancelShopifyNote.show().css('display', 'block');
                // Force display style to ensure it's visible
                cancelLabel.css('display', 'block');
                cancelContainer.css('display', 'block');
            } else {
                // Ensure cancel option is hidden and unchecked
                cancelLabel.hide();
                cancelContainer.hide();
                cancelShopifyNote.hide();
                if (cancelRadio.is(':checked')) {
                    cancelRadio.prop('checked', false);
                    // Check first option instead
                    const firstRadio = this.removeItemActionRadios.first();
                    if (firstRadio.length) {
                        firstRadio.prop('checked', true);
                    }
                }
            }
        } else {
            // For non-multi modes, ensure cancel option is hidden
            cancelLabel.hide();
            cancelContainer.hide();
            cancelShopifyNote.hide();
        }
        
        // Set default radio button (first one will be checked by default in the view)
        const firstRadio = this.removeItemActionRadios.first();
        if (firstRadio.length && !firstRadio.is(':checked')) {
            firstRadio.prop('checked', true);
        }

        // Update confirmation message based on selected action and mode
        this.updateConfirmationMessage();

        // Show the modal
        this.removeItemModal.modal('show');
        
        // After modal is fully shown, ensure cancel option visibility is correct
        // This handles the case where show.bs.modal event might interfere
        const modalShownHandler = () => {
            const MODE_SO_MULTI = 2;
            const MODE_SO_MULTI_CL = 7;
            const MODE_SO_MULTI_AMZ = 4;
            const MODE_SO_MULTI_AMZ_CL = 9;
            const MODE_SO_MULTI_CUSTOMER = 14;
            
            // Only handle for multi modes and single item removal (not bulk)
            const bulkItemIds = this.removeItemIdsInput.val() as string;
            if (bulkItemIds && bulkItemIds.trim().length > 0) {
                this.removeItemModal.off('shown.bs.modal', modalShownHandler);
                return; // Bulk delete handled separately
            }
            
            if (typeof waveOrderMode !== 'undefined' && 
                (waveOrderMode === MODE_SO_MULTI || waveOrderMode === MODE_SO_MULTI_CL || 
                 waveOrderMode === MODE_SO_MULTI_AMZ || waveOrderMode === MODE_SO_MULTI_AMZ_CL || waveOrderMode === MODE_SO_MULTI_CUSTOMER)) {
                // Re-check isLastItem from the button that opened the modal
                const itemId = this.removeItemIdInput.val() as string;
                if (itemId) {
                    const $btn = $(`.remove-item-btn[data-item-id="${itemId}"]`);
                    if ($btn.length) {
                        const isLastItemData = $btn.data('is-last-item');
                        const isLastItem = isLastItemData === true || isLastItemData === 'true' || isLastItemData === 1;
                        const cancelLabel = $('#remove_item_action_cancel_label');
                        const cancelContainer = $('#remove_item_action_cancel_container');
                        const cancelShopifyNote = $('.remove_item_cancel_shopify_note');
                        
                        if (isLastItem) {
                            cancelLabel.show();
                            cancelLabel.css('display', 'block');
                            cancelContainer.show();
                            cancelContainer.css('display', 'block');
                            cancelShopifyNote.show().css('display', 'block');
                        } else {
                            cancelLabel.hide();
                            cancelContainer.hide();
                            cancelShopifyNote.hide();
                        }
                    }
                }
            }
            
            // Remove handler after first use to prevent multiple bindings
            this.removeItemModal.off('shown.bs.modal', modalShownHandler);
        };
        
        this.removeItemModal.on('shown.bs.modal', modalShownHandler);
    }

    private updateConfirmationMessage(): void {
        const selectedAction = this.removeItemActionRadios.filter(':checked').val() as string;
        const itemIds = this.removeItemIdsInput.val() as string;
        const isBulkDelete = itemIds && itemIds.length > 0;
        const itemCount = isBulkDelete ? itemIds.split(',').length : 1;
        const MODE_TO = 5;
        const MODE_TO_CL = 10;
        
        // Default confirmation message
        let confirmationMessage = isBulkDelete 
            ? `Are you sure you want to delete ${itemCount} item(s) from the wave order?`
            : 'Are you sure you want to delete this item from the wave order?';
        
        // Show special message when action is "Remove the item" and mode is TO or TO_CL
        if (selectedAction === 'remove' && typeof waveOrderMode !== 'undefined' && 
            (waveOrderMode === MODE_TO || waveOrderMode === MODE_TO_CL)) {
            confirmationMessage = isBulkDelete
                ? `You are removing ${itemCount} TO item(s) from this wave order, and they will be ignored in the wave order processing, and you will not be able to pick them anymore. Are you sure?`
                : 'You are removing the TO items from this wave order, and they will be ignored in the wave order processing, and you will not be able to pick them anymore. Are you sure?';
        }
        
        this.removeItemConfirmation.text(confirmationMessage);
    }

    private handleConfirmRemove(): void {
        const itemId = this.removeItemIdInput.val() as string;
        const itemIds = this.removeItemIdsInput.val() as string;
        const reason = this.removeItemReasonTextarea.val() as string;
        const selectedAction = this.removeItemActionRadios.filter(':checked').val() as string;
        
        // Check if it's bulk delete mode
        const isBulkDelete = itemIds && itemIds.length > 0;
        
        const $mainRow = $(`.remove-item-btn[data-item-id="${itemId}"]`).closest('tr');
        const $expandedRow = $mainRow.next('tr.collapse');

        // Disable button and show loading
        this.removeItemBtn.prop('disabled', true);
        const originalText = this.removeItemBtn.text();
        this.removeItemBtn.html('<i class="fa fa-spinner fa-spin"></i> Processing...');

        const ajaxData: any = {
            reason: reason,
            remove_action: selectedAction
        };

        if (isBulkDelete) {
            ajaxData.item_ids = itemIds;
        } else {
            ajaxData.item_id = itemId;
        }

        $.ajax({
            url: removeItemPath,
            type: 'DELETE',
            data: ajaxData,
            success: (response: ApiResponse) => {
                if (response.success) {
                    // Close modal
                    this.removeItemModal.modal('hide');

                    if (isBulkDelete) {
                        // For bulk delete, reload the page
                        window.toastr_notifications.success(response.message || 'Items removed successfully!');
                        setTimeout(() => {
                            location.reload();
                        }, 500);
                    } else {
                        // For single delete, remove rows from DOM
                        $mainRow.fadeOut(300, function() {
                            $(this).remove();
                        });
                        if ($expandedRow.length && $expandedRow.hasClass('collapse')) {
                            $expandedRow.fadeOut(300, function() {
                                $(this).remove();
                            });
                        }
                        window.toastr_notifications.success(response.message || 'Item removed successfully!');
                        setTimeout(() => {
                            location.reload();
                        }, 500);
                    }
                } else {
                    this.removeItemBtn.prop('disabled', false);
                    this.removeItemBtn.text(originalText);
                    window.toastr_notifications.error(response.message || 'Failed to remove item(s).');
                }
            },
            error: (xhr: JQuery.jqXHR) => {
                this.removeItemBtn.prop('disabled', false);
                this.removeItemBtn.text(originalText);
                const errorMsg = 'Failed to remove item.';
                const response = xhr.responseJSON as ApiResponse;
                if (response && response.message) {
                    window.toastr_notifications.error(response.message);
                } else {
                    window.toastr_notifications.error(errorMsg);
                }
            }
        });
    }

    private resetModal(): void {
        this.removeItemIdInput.val('');
        this.removeItemIdsInput.val('');
        this.removeItemReasonTextarea.val('');
        // Reset to first radio button
        const firstRadio = this.removeItemActionRadios.first();
        if (firstRadio.length) {
            this.removeItemActionRadios.prop('checked', false);
            firstRadio.prop('checked', true);
        }
        // Hide cancel option for MODE_SO_MULTI, MODE_SO_MULTI_CL, MODE_SO_MULTI_AMZ, and MODE_SO_MULTI_AMZ_CL by default (will be shown if needed)
        const cancelLabel = $('#remove_item_action_cancel_label');
        const cancelContainer = $('#remove_item_action_cancel_container');
        const cancelShopifyNote = $('.remove_item_cancel_shopify_note');
        cancelLabel.hide();
        cancelContainer.hide();
        cancelShopifyNote.hide();
        this.removeItemConfirmation.text('');
        this.removeItemModalTitle.text('Remove Item');
        this.removeItemBtn.prop('disabled', false).text('Confirm');
    }

    public showBulkDeleteModal(itemIds: number[]): void {
        // Set bulk item IDs
        this.removeItemIdsInput.val(itemIds.join(','));
        this.removeItemIdInput.val('');
        
        // Update modal title
        this.removeItemModalTitle.text(`Remove ${itemIds.length} Item(s)`);
        
        // Clear the reason field and set default action
        this.removeItemReasonTextarea.val('');
        // Set default radio button (first one will be checked by default in the view)
        const firstRadio = this.removeItemActionRadios.first();
        if (firstRadio.length) {
            this.removeItemActionRadios.prop('checked', false);
            firstRadio.prop('checked', true);
        }
        
        // Handle bulk delete for multi modes: show cancel option only if all selected items complete their sales orders
        this.handleBulkDeleteCancelOption(itemIds);
        
        // Update confirmation message based on selected action and mode
        this.updateConfirmationMessage();
        
        // Show the modal - use setTimeout to ensure DOM is ready after modal show
        this.removeItemModal.modal('show');
        
        // Ensure cancel option visibility is set after modal is shown (in case modal show event hides it)
        setTimeout(() => {
            this.handleBulkDeleteCancelOption(itemIds);
        }, 100);
    }

    private handleBulkDeleteCancelOption(itemIds: number[]): void {
        const MODE_SO_MULTI = 2;
        const MODE_SO_MULTI_CL = 7;
        const MODE_SO_MULTI_AMZ = 4;
        const MODE_SO_MULTI_AMZ_CL = 9;
        const MODE_SO_MULTI_CUSTOMER = 14;
        
        // Only handle for multi modes
        if (typeof waveOrderMode === 'undefined' || 
            !(waveOrderMode === MODE_SO_MULTI || waveOrderMode === MODE_SO_MULTI_CL || 
              waveOrderMode === MODE_SO_MULTI_AMZ || waveOrderMode === MODE_SO_MULTI_AMZ_CL || waveOrderMode === MODE_SO_MULTI_CUSTOMER)) {
            return;
        }

        const cancelLabel = $('#remove_item_action_cancel_label');
        const cancelContainer = $('#remove_item_action_cancel_container');
        const cancelShopifyNote = $('.remove_item_cancel_shopify_note');
        const cancelRadio = $('#remove_item_action_cancel');

        // Get all selected items with their reference numbers
        const selectedItems: Array<{id: number, referenceNumber: string}> = [];
        itemIds.forEach(itemId => {
            const checkbox = $(`#wave_item_${itemId}`);
            if (checkbox.length) {
                const referenceNumber = checkbox.data('reference-number') as string;
                if (referenceNumber) {
                    selectedItems.push({ id: itemId, referenceNumber: referenceNumber });
                }
            }
        });

        if (selectedItems.length === 0) {
            cancelLabel.hide();
            cancelContainer.hide();
            cancelShopifyNote.hide();
            if (cancelRadio.is(':checked')) {
                cancelRadio.prop('checked', false);
                const firstRadio = this.removeItemActionRadios.first();
                if (firstRadio.length) {
                    firstRadio.prop('checked', true);
                }
            }
            return;
        }

        // Group selected items by reference_number
        const itemsByReference: {[key: string]: number[]} = {};
        selectedItems.forEach(item => {
            if (!itemsByReference[item.referenceNumber]) {
                itemsByReference[item.referenceNumber] = [];
            }
            itemsByReference[item.referenceNumber].push(item.id);
        });

        // Check if all items for each sales order are selected AND sales order has no items in other waves
        let allComplete = true;
        for (const referenceNumber in itemsByReference) {
            if (itemsByReference.hasOwnProperty(referenceNumber)) {
                // Get the total count of items for this reference_number in the wave from data attribute
                // Use the first selected item to get the total count (all items for same reference have same count)
                const firstSelectedItemId = itemsByReference[referenceNumber][0];
                const firstSelectedCheckbox = $(`#wave_item_${firstSelectedItemId}`);
                
                if (!firstSelectedCheckbox.length) {
                    allComplete = false;
                    break;
                }

                // Get total items count for this reference number from data attribute
                const totalItemsForReference = parseInt(firstSelectedCheckbox.data('total-items-for-reference') as string, 10) || 0;
                
                // Get selected item IDs for this reference_number (from the itemIds array passed to function)
                const selectedItemIdsForReference = itemsByReference[referenceNumber];

                // Check if all items for this reference_number in the current wave are selected
                // Compare the count of selected items with the total count
                if (totalItemsForReference === 0 || selectedItemIdsForReference.length !== totalItemsForReference) {
                    allComplete = false;
                    break;
                }

                // Check if this sales order has items in other waves (like chase list waves)
                // If it does, we should not show cancel option even if all items in current wave are selected
                const hasItemsInOtherWavesData = firstSelectedCheckbox.data('has-items-in-other-waves');
                const hasItemsInOtherWaves = hasItemsInOtherWavesData === true || 
                                             hasItemsInOtherWavesData === 'true' ||
                                             hasItemsInOtherWavesData === 1;
                if (hasItemsInOtherWaves) {
                    allComplete = false;
                    break;
                }
            }
        }

        // Show cancel option only if all sales orders are complete
        if (allComplete) {
            cancelLabel.show();
            cancelContainer.show();
            cancelShopifyNote.show().css('display', 'block');
            // Force display style to ensure it's visible (override any inline styles)
            cancelLabel.css('display', 'block');
            cancelContainer.css('display', 'block');
        } else {
            cancelLabel.hide();
            cancelContainer.hide();
            cancelShopifyNote.hide();
            // Uncheck cancel option if it was selected but not all items are complete
            if (cancelRadio.is(':checked')) {
                cancelRadio.prop('checked', false);
                const firstRadio = this.removeItemActionRadios.first();
                if (firstRadio.length) {
                    firstRadio.prop('checked', true);
                }
            }
        }
    }

    private handleDeleteNote(e: JQuery.ClickEvent): void {
        e.preventDefault();

        const noteId = $(e.currentTarget).data('note-id') as number;
        const $row = $(e.currentTarget).closest('tr');

        (window as any).swal({
            title: 'Are you sure?',
            text: 'This operation will delete the current note',
            icon: 'warning',
            buttons: true,
            dangerMode: true
        }).then((willDelete: boolean) => {
            if (willDelete) {
                $.ajax({
                    url: deleteNotePath,
                    type: 'DELETE',
                    data: {
                        note_id: noteId
                    },
                    success: (response: ApiResponse) => {
                        if (response.success) {
                            // Remove the row from the table
                            $row.fadeOut(300, function() {
                                $(this).remove();

                                // Check if there are no more notes and show empty message
                                if ($('#waveNotesTBody tr').length === 0) {
                                    const emptyRow = '<tr class="center-content">' +
                                        '<td colspan="5" class="text-center text-muted">No notes available</td>' +
                                        '</tr>';
                                    $('#waveNotesTBody').append(emptyRow);
                                }
                            });

                            window.toastr_notifications.success('Note deleted successfully!');
                        } else {
                            window.toastr_notifications.error(response.message || 'Failed to delete note.');
                        }
                    },
                    error: (xhr: JQuery.jqXHR) => {
                        const errorMsg = 'Failed to delete note.';
                        const response = xhr.responseJSON as ApiResponse;
                        if (response && response.message) {
                            window.toastr_notifications.error(response.message);
                        } else {
                            window.toastr_notifications.error(errorMsg);
                        }
                    }
                });
            }
        });
    }

    private handleCreateNote(e: JQuery.ClickEvent): void {
        e.preventDefault();

        const $btn = $('#createWaveNoteBtn');
        const noteText = $('#waveNoteFormMessage').val() as string;
        const important = $('#waveNoteFormImportant').is(':checked');

        if (!noteText || noteText.trim() === '') {
            window.toastr_notifications.warning('Please enter a note.');
            return;
        }

        // Set loading state
        $btn.prop('disabled', true);
        $btn.html('<i class="fa fa-spinner fa-spin"></i> Adding...');

        $.ajax({
            url: createNotePath,
            type: 'POST',
            data: {
                note: noteText,
                important: important
            },
            success: (response: ApiResponse) => {
                if (response.success && response.note) {
                    // Create new row HTML matching the new table structure
                    const importantIcon = response.note.important ? '<i class="fa fa-check text-danger"></i>' : '';
                    const dateTimeParts = response.note.created_at.split(' ');
                    const deleteIcon = canDeleteNotes 
                        ? `<a href="#" class="fa fa-trash-o fa-2x delete-icon delete-wave-note" title="Delete" data-toggle="tooltip" data-note-id="${response.note.id}"></a>` 
                        : `<span class="fa fa-trash-o fa-2x text-muted" style="cursor: not-allowed; opacity: 0.5;" title="You do not have permission to delete notes" data-toggle="tooltip"></span>`;
                    const newRow = `<tr class="center-content" data-note-id="${response.note.id}">` +
                        `<td class="heighter double-lines-content">` +
                        `${dateTimeParts[0]}<br/>${dateTimeParts[1]} ${dateTimeParts[2]}` +
                        `</td>` +
                        `<td style="text-align: left !important;">` +
                        `<span class="hover-cursor-pointer" title="${response.note.note}" data-toggle="tooltip" data-placement="top">` +
                        `${response.note.note.length > 80 ? response.note.note.substring(0, 80) + '...' : response.note.note}` +
                        `</span>` +
                        `</td>` +
                        `<td>${importantIcon}</td>` +
                        `<td>${response.note.user_name}</td>` +
                        `<td class="sn-icons">${deleteIcon}</td>` +
                        `</tr>`;

                    // Remove "No notes available" row if it exists
                    $('#waveNotesTBody tr td[colspan="5"]').parent().remove();

                    // Prepend new note to table
                    $('#waveNotesTBody').prepend(newRow);

                    // Clear form and close modal
                    $('#waveNoteFormMessage').val('');
                    $('#waveNoteFormImportant').prop('checked', false);
                    $('#addWaveNote').modal('hide');

                    window.toastr_notifications.success('Note added successfully!');
                } else {
                    window.toastr_notifications.error(response.message || 'Failed to create note.');
                }
            },
            error: (xhr: JQuery.jqXHR) => {
                const errorMsg = 'Failed to create note.';
                const response = xhr.responseJSON as ApiResponse;
                if (response && response.message) {
                    window.toastr_notifications.error(response.message);
                } else {
                    window.toastr_notifications.error(errorMsg);
                }
            },
            complete: () => {
                // Reset button state
                $btn.prop('disabled', false);
                $btn.html('Add');
            }
        });
    }

    private handleUnpickAsset(e: JQuery.ClickEvent): void {
        e.preventDefault();

        const $btn = $(e.currentTarget);

        if ($btn.hasClass('disabled') || $btn.css('pointer-events') === 'none') {
            return;
        }

        const assetId = $btn.data('asset-id') as number;
        const serialNumber = $btn.data('serial-number') as string;
        const $row = $btn.closest('tr');

        (window as any).swal({
            title: 'Are you sure?',
            text: 'This will unpick the asset with serial number: ' + serialNumber,
            icon: 'warning',
            buttons: true,
            dangerMode: true
        }).then((willUnpick: boolean) => {
            if (willUnpick) {
                // Disable button and show loading
                $btn.prop('disabled', true);
                $btn.html('<i class="fa fa-spinner fa-spin"></i>');

                $.ajax({
                    url: unpickAssetPath,
                    type: 'DELETE',
                    data: {
                        asset_id: assetId
                    },
                    success: (response: ApiResponse) => {
                        if (response.success) {
                            // Remove the row from the table
                            $row.fadeOut(300, function() {
                                $(this).remove();

                                // Check if there are no more assets in this item and show message
                                const $itemTable = $row.closest('table');
                                const $itemTbody = $itemTable.find('tbody');
                                if ($itemTbody.find('tr').length === 0) {
                                    const emptyRow = '<tr class="center-content">' +
                                        '<td colspan="10" class="text-center text-muted">No assets picked yet</td>' +
                                        '</tr>';
                                    $itemTbody.append(emptyRow);
                                }

                                location.reload();
                            });

                            window.toastr_notifications.success(response.message || 'Asset unpicked successfully!');
                        } else {
                            $btn.prop('disabled', false);
                            $btn.html('<i class="fa fa-times text-danger"></i>');
                            window.toastr_notifications.error(response.message || 'Failed to unpick asset.');
                        }
                    },
                    error: (xhr: JQuery.jqXHR) => {
                        $btn.prop('disabled', false);
                        $btn.html('<i class="fa fa-times text-danger"></i>');
                        const errorMsg = 'Failed to unpick asset.';
                        const response = xhr.responseJSON as ApiResponse;
                        if (response && response.message) {
                            window.toastr_notifications.error(response.message);
                        } else {
                            window.toastr_notifications.error(errorMsg);
                        }
                    }
                });
            }
        });
    }
}

declare global {
    interface Window {
        WOPPickingShow: WOPPickingShow;
        WaveItemCheckboxManager: WaveItemCheckboxManager;
    }
}

export function LoadPage(): void {
    InitPageStrict("wop pickings show", () => {
        const wopPickingShow = new WOPPickingShow();
        window.WOPPickingShow = wopPickingShow;
        
        // Initialize checkbox manager
        const checkboxManager = new WaveItemCheckboxManager();
        window.WaveItemCheckboxManager = checkboxManager;
    });
}

